import VaasCard from "~/v2/components/vaas/vaas-card"
import type { VaasListItem } from "~/v2/types/vaas"

const VaasCardList = ({ items }: { items: VaasListItem[] }) => {
  if (!items.length) {
    return (
      <div className="rounded-xl border border-dashed border-border bg-card p-10 text-center">
        <h2 className="text-lg font-semibold text-foreground">
          No VAAS items found
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Try different search text or status filter.
        </p>
      </div>
    )
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {items.map((item) => (
        <VaasCard item={item} key={item.courseId} />
      ))}
    </div>
  )
}

export default VaasCardList
